import qs from '@lumapps/base-api/qs';

import { setInitHeaders, type SetInitHeadersOptions } from '../utils/setInitHeaders';

export interface InitServiceOptions extends SetInitHeadersOptions {
    /** Optional customer identifier */
    customerSlug?: string;
    /** Optional instance identifier */
    instanceSlug?: string;
    /** Optional cell base URL */
    cell?: string;
    /** Optional initialization endpoint */
    initUrl?: string;
    /** Callback invoked when initial state is loaded */
    onInitialStateLoaded: () => void;
    /** list of fields to retrive from the init service */
    fields?: string[];
}

declare global {
    interface Window {
        initRequest?: XMLHttpRequest;
    }
}
/**
 * Initializes the service by sending a GET request to the specified init endpoint.
 * Sets custom headers and triggers a callback when the initial state is loaded.
 *
 * @param options - Configuration options for the initialization request.
 */
export const getInitService = (options: InitServiceOptions) => {
    // Build query string from customer and instance slugs
    const queryString = qs.stringify({
        customerHost: options.customerSlug,
        instanceSlug: options.instanceSlug,
        fields: options.fields ? options.fields.join(',') : undefined,
    });

    // Construct the full initialization URL
    const initUrl = `${options.cell}/service/${options.initUrl}?${queryString}`;

    // Create and configure the XMLHttpRequest
    window.initRequest = new XMLHttpRequest();
    window.initRequest.open('GET', initUrl);
    setInitHeaders(window.initRequest, options);

    // Send the request and set up the callback for when it loads
    window.initRequest.send();
    window.initRequest.addEventListener('load', options.onInitialStateLoaded);
};
